import * as Rx from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';

import type { ISelectProduct } from 'v2/interfaces/product/selectProduct';

import apiService from '../api';

import type { ApiService } from '../api';

export class SelectProduct {
  private isLoadingProducts$ = new Rx.BehaviorSubject<boolean>(true);
  private products$ = new Rx.BehaviorSubject<Array<ISelectProduct>>([]);

  constructor(private apiService: ApiService) {}

  public setProducts = (products: Array<ISelectProduct>) => {
    this.products$.next(products);
  };

  public getProducts = (): Rx.Observable<Array<ISelectProduct>> => this.products$;

  public isLoadingProducts = () => this.isLoadingProducts$;

  public loadDeliveries(endpoint?: string) {
    this.isLoadingProducts$.next(true);

    return this.apiService.get(endpoint ? endpoint : 'reports/sales-filter-products').pipe(
      tap((response) => this.products$.next(response.data)),
      finalize(() => this.isLoadingProducts$.next(false)),
      switchMap(() => this.getProducts())
    );
  }
}

const selectProduct = new SelectProduct(apiService);
export default selectProduct;
